/**
 * The one place that knows where things live in a `/polyline/preview`
 * response.
 *
 * This module exists because of a real bug. The endpoint-move distances were
 * read from two different paths in two different files — `ReviewPanel` took
 * them from the top level, `index.js` from under `candidate` — and the
 * backend can only put them in one place. The backend nests them (see
 * `LanePolylineService.preview`), so ReviewPanel's reader was `undefined` in
 * production and the "start moved by …" sentence, which is the whole reason
 * that callout exists, never rendered once.
 *
 * Neither test caught it, because each suite built its own payload in the
 * shape its own component expected. The mocks encoded the disagreement
 * instead of exposing it.
 *
 * So: no component reads these fields directly. If the payload shape ever
 * changes, it changes here, and every reader moves together or none does.
 */

/**
 * How far this candidate moves each terminus from the lane's stored geometry.
 *
 * Always returns numbers. A preview that has not arrived, or one from a
 * backend that does not report these, reads as "moved nothing" — which is the
 * safe direction: it understates an endpoint move rather than inventing one,
 * and the server measures it again before writing anything.
 */
export const endpointMovesFrom = (preview) => ({
  startMovedMeters: preview?.candidate?.startMovedMeters ?? 0,
  endMovedMeters: preview?.candidate?.endMovedMeters ?? 0,
});

/**
 * Whether either station list in this preview was capped.
 *
 * Both sides matter. A truncated CURRENT list makes the diff invent "gained"
 * stations that were only ever missing from a capped list; a truncated
 * CANDIDATE list hides stations that are about to lose bookability.
 */
export const stationsTruncatedIn = (preview) =>
  !!(preview?.current?.truncated || preview?.candidate?.truncated);
